window._ = require("lodash");
window.XLSX = require("xlsx");

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require("popper.js").default;
    window.$ = window.jQuery = require("jquery");

    require("bootstrap");
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require("axios");

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

import "datatables.net";
import "datatables.net-bs4";
import "@fortawesome/fontawesome-free/js/all";
import "jquery-mask-plugin";

//import * as jsPDF from 'jspdf'

window.jsPDF = require("jspdf");
window.autoTable = require("jspdf-autotable");
window.html2pdf = require("html2pdf.js");

import "select2";
require("select2/dist/js/i18n/pt-BR");

$(() => {
    $(".select2-enable").select2();
});

window.moment = require("moment");
moment().format();
moment.locale("pt-BR");
moment.defaultFormat = "DD/MM/YYYY";

$.ajaxSetup({
    headers: {
        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
    },
});

try {
    $(document).on({
        ajaxStart: function () {
            $("#_load").removeClass("d-none");
        },
        ajaxStop: function () {
            $("#_load").addClass("d-none");
        },
        ajaxSend: function () {
            //console.log('Enviando request');
        },
        ajaxComplete: function () {
            //console.log('Complete');
        },
        ajaxError: function (event, request, settings) {
            $("#_load").addClass("d-none");
        },
    });
} catch (err) {
    $("#_load").addClass("d-none");
}
